import * as EventEmitter from 'events';
import changePage from './changePage';
import {PiralInstance} from 'piral-core';
import DefaultEvents from './DefaultEvents';

export default function createDefaultEvents(eventMgr: EventEmitter,  piralInstance: PiralInstance): void
{
  eventMgr.on(DefaultEvents.PAGE_CHANGE, changePage.bind(null, piralInstance));

  eventMgr.on(DefaultEvents.ON_CONFIG_LOADED, function() {
    // currently not needed, add event on config loaded here in the future
  })

  
  eventMgr.on(DefaultEvents.ON_ALL_PILETS_INITIALIZED, function() {
    
    // currently not needed, add event on all pilets initialized here in the future

  });
}